/**
 * @returns true if plan has setup fee.
 */
export const hasSetupFee = plan => {
  return Boolean(plan.pricing?.feeConfigs?.[0]?.fee);
};

/**
 * @returns setup fee name or undefined if setup fee doesn't exist
 */
export const getSetupFeeName = plan => {
  return plan.pricing?.feeConfigs?.[0]?.fee?.name;
};

/**
 * @returns setup fee amount or undefined if setup fee doesn't exist
 */
export const getSetupFeeAmount = plan => {
  const amount = plan.pricing?.feeConfigs?.[0]?.fee?.amount;
  return amount ? amount : undefined;
};
//# sourceMappingURL=setup-fee.js.map